import { apiAxios } from '../utils/request.js'
// 提示列表
export const noticeList = (data, Istoast = false, Send = false) => {
  return apiAxios('post', 'shopapi/notice/list', data, Istoast, Send)
}
